export const OPENX_AGENT_POSITION_STORAGE_KEY = 'openx-agent:position';
export const OPENX_AGENT_SIZE_STORAGE_KEY = 'openx-agent:size';
export const OPENX_AGENT_OPEN_STORAGE_KEY = 'openx-agent:isOpen';
export const OPENX_AGENT_PERSONA_AVATARS_STORAGE_KEY = 'openx-agent:personaAvatars';
